import { QueryCompiler } from "./QueryCompiler.js";
import { RootObjectBuilder } from "./RootObjectBuilder.js";
class QueryBuilder {
  query(builder) {
    if (!(builder instanceof RootObjectBuilder)) {
      builder = builder(new RootObjectBuilder());
    }
    const compiler = new QueryCompiler("query", builder);
    return compiler.create();
  }
  mutation(builder) {
    if (!(builder instanceof RootObjectBuilder)) {
      builder = builder(new RootObjectBuilder());
    }
    const compiler = new QueryCompiler("mutation", builder);
    return compiler.create();
  }
}
export {
  QueryBuilder
};
//# sourceMappingURL=QueryBuilder.js.map
